<div class="api-exposure-page" *ngIf="recipientsData$()?.length; else noData">
  <div class="top-area">
    <div class="info-banner">
      <button type="button" class="info-banner__close">×</button>
      <div class="info-banner__text" translate>apiExposure.infoBanner</div>
    </div>

    <div class="selection-strip">
      <button type="button" class="selection-strip__close">×</button>

      <div class="selection-strip__actions">
        <div class="selection-counter">
          <span>{{ getSelectedItems().length }}</span>
          <span translate>apiExposure.selectedItems</span>
        </div>

        <button type="button" class="ghost-chip">
          <span translate>apiExposure.rejectSelected</span>
          <span class="ghost-chip__close">×</span>
        </button>

        <button type="button" class="approve-chip" [ngClass]="{ 'disabled': getSelectedItems().length === 0 }"
          (click)="getSelectedItems().length === 0 ? null : sendSelectedToApi()">
          <span translate>apiExposure.sendSelected</span>
          <span class="approve-chip__check">✓</span>
        </button>
      </div>
    </div>
  </div>

  <div class="table-shell">
    <div class="table-scroll">
      <table class="api-exposure-table">
        <thead>
          <tr>
            <th class="status-col" translate>status</th>
            <th class="answer-col" translate>answer</th>
            <th class="question-col" translate>question</th>
            <th class="date-col" translate>submittedAt</th>
            <th class="spacer-col"></th>
            <th class="user-col">
              <div class="user-header-box">
                <div class="header-checkbox-wrap">
                  <span translate>performedBy</span>
                  <div class="custom-checkbox header-checkbox" (click)="toggleSelectAll()">
                    <div class="choose" [ngClass]="{ 'selected': selectAll }">
                      <div class="inner-selected">
                        <img src="/assets/images/auto-fill/vi.svg" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let recipientData of recipientsData$(); let i = index">
            <tr *ngFor="let qa of recipientData.questions; let j = index" [ngClass]="{
                'disabled-row': qa.enableEdit === false,
                'group-first-row': j === 0,
                'group-last-row': j === recipientData.questions.length - 1
              }">
              <td class="status-cell">
                <span class="already-updated-badge" *ngIf="qa.enableEdit === false" translate>
                  apiExposure.alreadyUpdated
                </span>
              </td>

              <td class="answer-cell">
                <span class="answer-text">
                  {{ getApiExposureAnswerText(qa.answer, qa.question) || (qa.answer | answerSwitchType:qa.question) }}
                </span>
              </td>

              <td class="question-cell">
                <div class="question-cell-content">
                  <div class="custom-checkbox row-checkbox" [ngClass]="{ 'disabled': qa.enableEdit === false }"
                    [title]="qa.enableEdit === false ? ('apiExposure.alreadyUpdated' | translate) : ''"
                    (click)="qa.enableEdit !== false ? toggleQuestionSelection(i, j) : null">
                    <div class="choose" [ngClass]="{ 'selected': isQuestionSelected(i, j) }">
                      <div class="inner-selected">
                        <img src="/assets/images/auto-fill/vi.svg" alt="" />
                      </div>
                    </div>
                  </div>

                  <div class="question-texts">
                    <div class="question-title">{{ qa.question | questionTitle }}</div>
                    <div class="question-sub" *ngIf="qa.apiExposureFieldName">
                      ({{ qa.apiExposureFieldName }})
                    </div>
                  </div>
                </div>
              </td>

              <td class="date-group-cell" *ngIf="j === 0" [attr.rowspan]="recipientData.questions.length">
                {{ recipientData.recipient.dateAnswered | date:'dd.MM.yyyy' }}
              </td>

              <td class="spacer-cell" *ngIf="j === 0" [attr.rowspan]="recipientData.questions.length"></td>

              <td class="user-group-cell" *ngIf="j === 0" [attr.rowspan]="recipientData.questions.length">
                <div class="user-cell-box">
                  <div class="user-group-header">
                    <div class="user-meta">
                      <span class="user-avatar">
                        {{ getInitials(recipientData.recipient.user) }}
                      </span>
                      <span class="user-name">
                        {{ recipientData.recipient.user.firstName }}
                        {{ recipientData.recipient.user.lastName }}
                      </span>


                    </div>
                    <div class="custom-checkbox recipient-checkbox" (click)="toggleRecipientSelection(i)">
                      <div class="choose" [ngClass]="{
                          'selected': isRecipientFullySelected(i),
                          'partial': isRecipientPartiallySelected(i)
                        }">
                        <div class="inner-selected">
                          <img src="/assets/images/auto-fill/vi.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <div class="floating-actions" *ngIf="getSelectedItems().length > 0">
    <button type="button" class="floating-actions__close">×</button>

    <div class="floating-actions__content">
      <div class="floating-actions__count">
        <span>{{ getSelectedItems().length }}</span>
        <span translate>apiExposure.selectedItems</span>
      </div>

      <button type="button" class="floating-actions__reject">
        <span translate>apiExposure.rejectSelected</span>
        <span class="floating-actions__reject-close">×</span>
      </button>

      <button type="button" class="floating-actions__approve" (click)="sendSelectedToApi()">
        <span translate>apiExposure.sendSelected</span>
        <span class="floating-actions__approve-check">✓</span>
      </button>
    </div>
  </div>
</div>

<ng-template #noData>
  <que-no-result *ngIf="!loadingData$(); else load" [isData]="true"></que-no-result>
</ng-template>

<ng-template #load>
  <div class="load-warp">
    <div class="load-item" *ngFor="let _ of [].constructor(4)"></div>
  </div>
</ng-template>